<template>
    <div v-if="type=='poster'" class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
        <div class="imagebox-courses-type1">
            <div class="featured-post">
                <i class="fa fa-5x fa-image" v-if="!course.imageFileName"></i>
                <img v-else src="course | s3url" alt="images" class="course-card">
            </div>
            <div class="author-info">
                <div class="avatar">
                    <img v-bind:src="course.author | s3url" style="width:65px; border-radius: 50px;">
                </div>
                <div class="category">
                    {{ course.name }}
                </div>
                <div class="name">
                    <router-link :to="{ name: 'CourseInfo', params: { id: course.id }}">Learn More ...</router-link>
                </div>
                <div class="add-cart">
                    <router-link class="add-cart-a btn-site-primary" v-if="course.userAssigned" :to="{ name: 'CourseDetails', params: { id: course.id }}">CONTINUE</router-link>
                    <button v-else class="add-cart-a btn-site-primary" v-on:click="addToCart">{{ course.price > 0 ? "Add to cart" : "Enrol" }}</button>
                </div>
                <div class="border-bt">

                </div>
                <div class="evaluate">
                    <div class="price">
                        <span class="price-now">{{ course.price ? 'R' + course.price: '' }}<span v-if="course.price" class="text-smaller"> Excl. VAT</span></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div v-else-if="type == 'card' || type == null" class="flat-course clearfix row bg-white">

        <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
            <div class="featured-post" style="height: 100%">
                <div class="entry-image">
                    <i class="fa fa-5x fa-image" v-if="!course.imageFileName" style="margin-left: 150%; margin-top: 50%"></i>
                    <img v-else v-bind:src="course | s3url" alt="images" class="entry-image-img">
                </div>
            </div>
        </div>

        <div class="col-lg-9 col-md-9 col-sm-12 col-xs-12">
            <div class="course-content clearfix" style="margin-bottom: 9px">
                <div class="wrap-course-content">
                    <div class="wrap-rating-price">
                        <div class="meta-rate row">
                            <div class="col-lg-9 col-md-9 col-12">
                                <h4 class="main-title-text" style="padding: 0px 18px 0px 0px;">
                                    <router-link v-if="course.userAssigned" :to="{ name: 'CourseDetails', params: { id: course.id }}">{{ course.name }}</router-link>
                                    <router-link v-else :to="{ name: 'CourseInfo', params: { id: course.id }}">{{ course.name }}</router-link>
                                </h4>
                            </div>
                            <div class="col-lg-3 col-md-3 col-12" v-if="!course.userAssigned">
                                <div class="">
                                    <span v-if="course.priceUsd" class="price-now">{{ course.priceUsd ? '$' + course.priceUsd : '' }}<span v-if="course.priceUsd" class="text-smaller"> Excl. VAT</span></span>
                                    <span v-else class="price-now">{{ course.price ? 'R' + course.price : '' }}<span v-if="course.price" class="text-smaller"> Excl. VAT</span></span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <p>
                        {{ course.descriptionShort }}
                    </p> 
                    <div v-if="!course.userAssigned" class="mt-2">
                        <router-link class="add-cart-a btn-site-primary" :to="{ name: 'CourseInfo', params: { id: course.id }}" style="padding: 9px 38px 9px 38px;">VIEW MORE</router-link>
                        <button class="add-cart-a btn-site-primary" v-on:click="addToCart" style="padding: 9px 38px 9px 38px;">{{ course.price > 0 ? "ADD TO CART" : "ENROL" }}</button>
                    </div>
                    <div v-if="course.userAssigned && !course.completed" class="mt-2">
                        <router-link class="add-cart-a btn-site-primary" :to="{ name: 'CourseDetails', params: { id: course.id }}" style="padding: 9px 38px 9px 38px;">CONTINUE</router-link>
                    </div>
                    <div v-if="course.userAssigned && course.completed" class="mt-2">
                        <router-link class="add-cart-a btn-site-primary" :to="{ name: 'CourseDetails', params: { id: course.id }, hash: '#certificate'}" style="padding: 9px 38px 9px 38px;">VIEW RESULTS</router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>

    .entry-image {
        height: 100%;
        border: 2px solid rgb(61, 60, 121);
        border-radius: 10px;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .featured-post {
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .entry-image-img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }

    .text-smaller {
        font-size: 12px;
        white-space: nowrap;
    }

    .enroll a {
        padding: 12px 40px;
        border-radius: 34px;
        display: inline-block;
        background: #fecc00;
        color: #fff !important;
        font-size: 13px;
        font-weight: 500;
        text-transform: inherit;
        box-shadow: 0 8px 6px -6px black;
    }

    .enroll {
        padding-top: 15px;
    }

    .add-cart-a {
        padding: 12px 35px 12px 35px;
        border-radius: 34px;
        display: inline-block;
        background: #fecc00;
        color: #fff !important;
        font-size: 13px;
        font-weight: 500;
        text-transform: inherit;
        box-shadow: 0 8px 6px -6px black;
        margin-right: 5px;
        margin-bottom: 10px;
    }
</style>
<script>
    export default {
        name: 'CourseCardComponent',
        props: {
            course: Object,
            type: String
        },
        methods: {
            addToCart() {
                this.$store.commit("addToCart", {
                    type: "course",
                    id: this.course.id,
                    name: this.course.name,
                    price: this.course.price,
                    priceUsd: this.course.priceUsd,
                    imageFileName: this.course.imageFileName
                });
            }
        },
        computed: {

        }
    }
</script>

<style scoped>
</style>